<template>
  <div class="section-main__warp">
    <div class="standard-factor">
      <div class="left">
        <div class="title">标准因子库</div>
        <div class="content">
          <el-table ref="menuTable" :show-header="false" :data="menuData" highlight-current-row
            @row-click="handleRowClick">
            <el-table-column prop="name"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="right">
        <div v-if="menuValue == '1'">
          <FuelRelated ref="fuelRealted"></FuelRelated>
        </div>
        <div v-if="menuValue == '2'">
          <ElectricityEmissions ref="ElectricityEmissions"></ElectricityEmissions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FuelRelated from "./fuelRelated";
import ElectricityEmissions from "./electricityEmissions"
export default {
  components: {
    FuelRelated,
    ElectricityEmissions
  },
  data() {
    return {
      menuData: [],
      menuValue: '1'
    }
  },
  mounted() {
    this.getMenuData()
  },
  methods: {
    getMenuData() {
      this.menuData = [{ 'id': '1', 'name': '燃料相关系数管理' }, { 'id': '2', 'name': '电力排放因子管理' }]
      this.$refs.menuTable.setCurrentRow(this.menuData[0])
      this.menuValue = '1'
      this.$refs.fuelRealted.getList()
    },
    handleRowClick(row) {
      if (row.id == '1') {
        this.menuValue = '1'
      } else if (row.id == '2') {
        this.menuValue = '2'
      }
    }
  }
}
</script>

<style>
.standard-factor .el-table__body td.el-table__cell {
  cursor: pointer;
}

.standard-factor .el-table__body tr.current-row>td.el-table__cell {
  background-color: rgb(215, 232, 255);
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.standard-factor {
  width: 100%;
  height: 100%;
  display: flex;

  .left {
    width: 300px;
    height: 100%;
    background-color: #ffffff;

    .title {
      margin: 16px 0 16px 16px;
      border-left: 5px solid #407aee;
      padding-left: 10px;
      font-size: 16px;
    }

    .content {
      padding: 20px 10px 20px 20px;
    }
  }

  .right {
    flex: 1;
    margin-right: -16px;
    height: 100%;
  }
}
</style>